import TenDaysMVPTerms from './TenDaysMVPTerms';
export default TenDaysMVPTerms;
